import { createFileRoute, redirect } from '@tanstack/react-router';

//** Redirect to /bulk/$subNav/$type/$id/editor */
export const Route = createFileRoute('/bulk_/$subNav_/$type_/$id')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/bulk/$subNav/$type/$id/$view',
      params: {
        ...params,
        view: 'editor',
      } as any, // Cast to any and let the destination route validate the params
      search,
    });
  },
});
